'use strict';
import { j as e } from "../../external/react/jsx-runtime.js";
import { faSpinnerThird as m } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { FontAwesomeIcon as l } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import a from "../../external/classnames/index.js";
const d = ({
  fullScreen: s = !1,
  size: i = "w-12 h-12",
  inline: t = !1,
  text: r,
  textSize: o = "text-base"
}) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: a("bg-inherit", {
      "w-screen h-screen fixed z-100": s,
      "inline-block": t,
      "w-full min-h-24 relative": !s && !t
    }),
    children: /* @__PURE__ */ e.jsx(
      "div",
      {
        className: a({
          "p-12 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2": s || !t
        }),
        children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ e.jsx(
            l,
            {
              icon: m,
              className: i,
              spin: !0
            }
          ),
          r && /* @__PURE__ */ e.jsx(
            "p",
            {
              className: a(
                "mt-4 text-gray-600 text-center",
                o
              ),
              children: r
            }
          )
        ] })
      }
    )
  }
);
export {
  d as default
};
